<div>
  <div class="tab">
    <button
      *ngIf="hasResourcesForTab('network')"
      type="button"
      id="network-tab"
      [ngClass]="{ active: isActiveTab('network') }"
      (click)="setTab('network')"
    >
      <h3 [ngClass]="{ inactive: !isActiveTab('network') }">Network</h3>
    </button>
    <button
      *ngIf="hasResourcesForTab('compute')"
      type="button"
      id="compute-tab"
      [ngClass]="{ active: isActiveTab('compute') }"
      (click)="setTab('compute')"
    >
      <h3 [ngClass]="{ inactive: !isActiveTab('compute') }">Compute</h3>
    </button>
    <button
      *ngIf="hasResourcesForTab('storage')"
      type="button"
      id="storage-tab"
      [ngClass]="{ active: isActiveTab('storage') }"
      (click)="setTab('storage')"
    >
      <h3 [ngClass]="{ inactive: !isActiveTab('storage') }">Storage</h3>
    </button>
    <button
      *ngIf="hasResourcesForTab('k8s')"
      type="button"
      id="k8s-tab"
      [ngClass]="{ active: isActiveTab('k8s') }"
      (click)="setTab('k8s')"
    >
      <h3 [ngClass]="{ inactive: !isActiveTab('k8s') }">Kubernetes</h3>
    </button>
    <button
      *ngIf="hasResourcesForTab('other')"
      type="button"
      id="other-tab"
      [ngClass]="{ active: isActiveTab('other') }"
      (click)="setTab('other')"
    >
      <h3 [ngClass]="{ inactive: !isActiveTab('other') }">Other</h3>
    </button>
  </div>
  <div id="resource-selector-box" class="with-tabs">
    <ng-container
      *ngIf="!readonly && refreshing && sourceResources && sortedResourcesByType.length === 0; else hasResourcesBlock"
    >
      <div class="loading-message">
        <i class="fa-solid fa-spinner fa-spin"></i> Querying primary environment for resources...
      </div>
    </ng-container>
    <ng-template #hasResourcesBlock>
      <ng-container *ngIf="sortedResourcesByType.length === 0 && readonly">
        <div class="no-resources-message">No resources configured for this application.</div>
      </ng-container>
      <ng-container *ngFor="let resourceTypeData of sortedResourcesByType">
        <div class="resource-type" id="navattic-resource-type-container">
          <span class="resource-type-name">
            {{ getResourceTypePluralDisplayText(resourceTypeData.resourceTypeDetails) }}
            <ng-container *ngIf="resourceSupportsRealTimeReplication(resourceTypeData.resourceTypeDetails)">
              <span class="real-time-replicated">(Real-time Replicated)</span>
            </ng-container>
          </span>

          <div class="tree-root" *ngIf="resourceTypeData.nodes.length <= 1000">
            <ng-container *ngFor="let node of resourceTypeData.nodes; trackBy: nodeTrackBy">
              <tree-node
                [node]="node"
                [displayChildren]="true"
                [readonly]="readonly"
                (selectionChange)="onNodeSelectionChanged($event)"
                (expand)="onNodeExpanded($event)"
                (collapse)="onNodeCollapsed($event)"
              ></tree-node>
            </ng-container>
          </div>

          <p-scroller
            *ngIf="resourceTypeData.nodes.length > 1000"
            [items]="resourceTypeData.nodes"
            [itemSize]="36"
            scrollHeight="600px"
            [style]="{ width: '100%', height: '600px' }"
            styleClass="tree-root"
          >
            <ng-template pTemplate="item" let-node>
              <tree-node
                [node]="node"
                [readonly]="readonly"
                (selectionChange)="onNodeSelectionChanged($event)"
                (expand)="onNodeExpanded($event)"
                (collapse)="onNodeCollapsed($event)"
              ></tree-node>
            </ng-template>
          </p-scroller>
        </div>
      </ng-container>
    </ng-template>
  </div>
</div>
